export default __webpack_public_path__ + "static/media/17.142e681d.png";